import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { CalendarDays, BookOpen, Newspaper, Users, ArrowLeft } from "lucide-react";

const links = [
  { to: "/admin/events", label: "Events", icon: CalendarDays },
  { to: "/admin/resources", label: "Resources", icon: BookOpen },
  { to: "/admin/news", label: "Initiatives", icon: Newspaper },
  { to: "/admin/committees", label: "Committees", icon: Users },
];

export default function AdminLayout() {
  const location = useLocation();
  const active = links.find((l) => location.pathname.startsWith(l.to)) || links[0];

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12" data-testid="admin-layout">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <div className="overline">Administrator</div>
          <h1 className="mt-3 font-heading text-4xl">Manage {active.label.toLowerCase()}</h1>
        </div>
        <Link to="/dashboard" className="text-sm text-[color:var(--azsam-ink-soft)] hover:text-[color:var(--azsam-clay)] inline-flex items-center gap-1" data-testid="admin-back-dashboard">
          <ArrowLeft size={14} /> Back to member portal
        </Link>
      </div>

      <div className="mt-10 grid lg:grid-cols-12 gap-8">
        <aside className="lg:col-span-3">
          <nav className="azsam-card p-4 flex lg:flex-col gap-1 overflow-x-auto" data-testid="admin-nav">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`admin-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-md text-sm whitespace-nowrap transition-colors ${
                    isActive ? "bg-[color:var(--azsam-clay)] text-white" : "hover:bg-[color:var(--azsam-cream)]"
                  }`
                }
              >
                <l.icon size={16} strokeWidth={1.6} /> {l.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <section className="lg:col-span-9">
          <Outlet />
        </section>
      </div>
    </div>
  );
}
